// src/api/support_api.js
import axios from "axios";
import { api } from "./api_route";

export const createSupportTicket_api = async (payload) => {
  try {
    const response = await axios.post(`${api}/support/createTicket`, payload);
    return response.data; // Return only data on success
  } catch (error) {
    const errorPayload = {
      status: error.response?.status || null,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Network error occurred",
    };

    throw errorPayload;
  }
};
